<template>
  <a href='javascript:void(0)'
     class='is-pulled-left is-medium has-text-primary'
     @click.prevent='perform'><b-icon icon='angle-left'></b-icon></a>
</template>

<script>
  export default {
    name: 'HistoryBack',
    props: {
      pathName: {
        type: String,
        default: () => ''
      },
      params: Object
    },
    methods: {
      perform () {
        if (this.pathName === '') {
          window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        } else {
          this.$router.replace({ name: this.pathName, params: this.params })
        }
      }
    }
  }
</script>

<style lang='scss' scoped>
  a {
    font-size: 2em;
    padding-right: 0.7em;
  }
</style>




// WEBPACK FOOTER //
// src/components/actions/HistoryBack.vue